module.exports = __webpack_public_path__ + "static/media/online-training.b6c027ba.svg";